import * as React from 'react'
import { Redirect } from 'react-router-dom'
import { Datepicker } from '@mobiscroll/react'
import moment, { Moment } from 'moment'
import { metersToMiles, milesToMeters, secondsToHours } from 'src/utils'
import UIMessages from 'src/utils/ui-messages'
import { IDriverEditSessionObject, IDriverSessionFilters } from 'src/types/driver'
import Modal from '../ui/Modal'
import { Input, Select } from '@mobiscroll/react-latest'
import { withNotification } from '../ui/notification-provider'

export interface ISessionHistoryEditTimeModalProps {
  filters: IDriverSessionFilters
  history: any
  location: any
  match: any
  operatorId: string
  getDriversSessionList: (filters: IDriverSessionFilters) => any
  saveData: (request: IDriverEditSessionObject) => any
  notification: any
}

interface ISessionHistoryEditTimeModalModalState {
  clockIn: string | undefined
  clockInDisplay: string
  clockOut: string | undefined
  clockOutDisplay: string
  distanceTraveled: string | undefined
  error: string
  id: string
  isModalOpen: boolean
  isSubmitting: boolean
  originalClockIn: string | undefined
  originalClockOut: string | undefined
  redirect: boolean
  timeDelta: string
  sessionType: 'work_time' | 'standby' | 'after_hours' | 'break'
}

interface ISelectOption {
  text: string
  value: string
}

const sessionTypeOptions: ISelectOption[] = [
  { text: 'Work Time', value: 'work_time' },
  { text: 'Break', value: 'break' }
]

class SessionHistoryEditTimeModal extends React.Component<
  ISessionHistoryEditTimeModalProps,
  ISessionHistoryEditTimeModalModalState
> {
  constructor(props: ISessionHistoryEditTimeModalProps) {
    super(props)

    const clockInDate = new Date(props.location.state.element.checkInTime)
    const clockOutDate = new Date(props.location.state.element.checkOutTime)
    const displayCheckIn = moment(props.location.state.element.checkInTime).format('MM/DD/YYYY HH:mm')
    const displayCheckOut = moment(props.location.state.element.checkOutTime).format('MM/DD/YYYY HH:mm')
    const { sessionType } = props.location.state.element

    this.state = {
      clockIn: moment(clockInDate).toISOString(),
      clockInDisplay: displayCheckIn,
      clockOut: moment(clockOutDate).toISOString(),
      clockOutDisplay: displayCheckOut,
      distanceTraveled: metersToMiles(props.location.state.element.distanceTravel),
      error: '',
      id: props.location.state.element.id,
      isModalOpen: true,
      isSubmitting: false,
      originalClockIn: moment(clockInDate).format(),
      originalClockOut: moment(clockOutDate).format(),
      redirect: false,
      timeDelta: this.getTimeDelta(moment(clockInDate), moment(clockOutDate)),
      sessionType
    }

    this.handleCancelClick = this.handleCancelClick.bind(this)
    this.handleChangeClock = this.handleChangeClock.bind(this)
    this.handleDistanceTraveledChanged = this.handleDistanceTraveledChanged.bind(this)
    this.saveData = this.saveData.bind(this)
  }

  public render() {
    const { clockInDisplay, clockOutDisplay, distanceTraveled, isSubmitting, sessionType, timeDelta } = this.state

    if (this.state.redirect === true || this.state.isModalOpen === false) {
      return <Redirect to={`/drivers/${this.props.operatorId}/session-history`} />
    }

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='med-modal'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>EDIT TIME</span>
            <div
              style={{
                pointerEvents: this.state.isSubmitting ? 'none' : 'auto',
                opacity: this.state.isSubmitting ? 0.4 : 1.0
              }}
              className='mt1 border-top'
            >
              <div className='col-12'>
                {(sessionType === 'break' || sessionType === 'work_time') && (
                  <div className='mt1'>
                    <Select
                      data={sessionTypeOptions}
                      inputStyle='box'
                      label={'Session Type'}
                      labelStyle='floating'
                      theme='ios'
                      themeVariant='light'
                      value={sessionType}
                      onChange={({ value }) => this.selectSessionType(value)}
                    />
                  </div>
                )}
                <div className='dsh-edit-clock-in-out-wrapper flex flex-column mt1'>
                  <label className='ml1 h5'>Clock In/Out</label>
                  <Datepicker
                    controls={['calendar', 'time']}
                    dateFormat='MM/DD/YYYY'
                    inputProps={{
                      className: 'session-history-picker add-time'
                    }}
                    rangeEndLabel='Out'
                    rangeStartLabel='In'
                    select='range'
                    timeFormat='HH:mm'
                    value={[moment(clockInDisplay), moment(clockOutDisplay)]}
                    onChange={({ value }) => this.handleChangeClock(value)}
                  />
                </div>
                <div className='mt1 ml1'>
                  <label className='h6'>Duration {timeDelta}</label>
                </div>
                <div className='mt1'>
                  <Input
                    className='mobiscroll-input'
                    name='coordinates'
                    placeholder={'Distance in miles'}
                    type='text'
                    value={distanceTraveled}
                    onChange={this.handleDistanceTraveledChanged}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`Distance Travelled`}
                    labelStyle='floating'
                  />
                </div>
                <div className='flex justify-end mt2 w100'>
                  <button
                    className='CancelButton custom-btn mbsc-clear-btn'
                    disabled={isSubmitting}
                    type='button'
                    onClick={this.handleCancelClick}
                  >
                    {UIMessages.common.cancel}
                  </button>
                  <button
                    className='SubmitButton custom-btn mbsc-green-btn ml1'
                    disabled={isSubmitting}
                    type='button'
                    onClick={this.saveData}
                  >
                    Save Time
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private selectSessionType = (value: 'work_time' | 'standby' | 'after_hours' | 'break') => {
    this.setState({ sessionType: value })
  }

  private handleChangeClock = (value: Date[]) => {
    const [clockIn, clockOut] = value
    if (moment(clockIn).isValid() && moment(clockOut).isValid()) {
      const clockInDate = moment(clockIn)
      const clockOutDate = moment(clockOut)
      this.setState(
        {
          clockIn: clockInDate.toISOString(),
          clockInDisplay: clockInDate.format('MM/DD/YYYY HH:mm')
        },
        () => {
          this.setState({
            clockOut: clockOutDate.toISOString(),
            clockOutDisplay: clockOutDate.format('MM/DD/YYYY HH:mm'),
            timeDelta: this.getTimeDelta(clockInDate, clockOutDate)
          })
        }
      )
    }
  }

  private handleDistanceTraveledChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ distanceTraveled: `${e.target.value}` })
  }

  private handleCancelClick = () => {
    this.setState({ isModalOpen: false })
  }

  private getTimeDelta = (clockInDate: Moment, clockOutDate: Moment) => {
    const duration = moment.duration(clockOutDate.diff(clockInDate))
    const seconds = duration.asSeconds()
    return secondsToHours(seconds, true)
  }

  private saveData = async () => {
    const { operatorId, getDriversSessionList, saveData, notification } = this.props
    const { clockIn, clockOut, error, distanceTraveled, id, sessionType } = this.state

    const session: IDriverEditSessionObject = {
      checkInTimeUpdated: moment(clockIn).toISOString(),
      checkOutTimeUpdated: moment(clockOut).toISOString(),
      distanceTraveled: milesToMeters(Number(distanceTraveled)),
      id,
      sessionType
    }

    if (error !== '' || !error) {
      const res = await saveData(session)
      this.setState({
        isSubmitting: true,
        redirect: true
      })

      if (!res || res.data.success === false) {
        notification.addNotification({
          title: res && res.data.message ? res.data.message : 'Session not saved. Check for overlapping time.',
          level: 'error'
        })
      } else {
        const newFilters = {
          ...this.props.filters,
          timeZone: moment(this.props.filters.fromDate).format('Z')
        }
        await getDriversSessionList({ ...newFilters, operatorId })

        notification.addNotification({
          title: 'Successfully updated time!',
          level: 'success'
        })
      }
    }
  }
}

export default withNotification(SessionHistoryEditTimeModal)



// WEBPACK FOOTER //
// ./src/components/drivers/SessionHistoryEditTimeModal.tsx